import { Navigate } from "react-router-dom";

const getUserVerification = () => {
    try {
        return JSON.parse(localStorage.getItem("userVerificationId"));
    } catch (error) {
        return "";
    }
};

const getStoreData = () => {
    try {
        return JSON.parse(localStorage.getItem("ecommerce"));
    } catch (error) {
        return "";
    }
};

const getHeaderColor = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.headerColor;
    } catch (error) {
        return "";
    }
};


const getFooterColor = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.foooterColor;
    } catch (error) {
        return "";
    }
};

const getButtonColor = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.buttonColor;
    } catch (error) {
        return "";
    }
};

const getButtonTextColor = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.buttonTextColor;
    } catch (error) {
        return "";
    }
};

const getStoreName = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.storeName.toUpperCase();
    } catch (error) {
        return "";
    }
};

const getOrganizationId = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.organizationId;
    } catch (error) {
        return "";
    }
};

const getParentOrganizationId = () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.storeDetails.parentOrganizationId;
    } catch (error) {
        return "";
    }
};

const getDataById = (key) => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data[key];
    } catch (error) {
        return "";
    }
};

const setStoreData = async (data) => {
    try {
        const storeData = JSON.stringify(data);
        localStorage.setItem("ecommerce", storeData);
        return "";
    } catch (error) {
        return "";
    }
};

const setTokenData = async (data) => {
    try {
        localStorage.setItem("token", data);
        localStorage.setItem("isLogin", true);
        return "";
    } catch (error) {
        return "";
    }
};

const getTokenData = () => {
    try {

        return localStorage.getItem("token");
    } catch (error) {
        return false
    }
};

const checkLogin = () => {
    try {
        localStorage.getItem("isLogin");
        return true;
    } catch (error) {
        return false;
    }
};

const setUserData = async (data) => {
    try {
        localStorage.setItem("userInfo", JSON.stringify(data));
        return "";
    } catch (error) {
        return "";
    }
};

const getUserData = () => {
    try {
        return JSON?.parse(localStorage.getItem("userInfo"));
    } catch (error) {
        return "";
    }
};

const getCurrency = () => {
    try {
        const userInfo = JSON?.parse(localStorage.getItem("userInfo"));
        const country = userInfo?.storeDetails?.countryName ; // need to ask if we are getting country code
        switch (country) {
            case 'USA':
                 return '£' ;
                
            case 'United Kingdom':
                return '$' ;
           
        
            default:
                return '$' ;
               
        }
    } catch (error) {
        return "";
    }
};

const getStoreLanguage = () => {
    try {
        const userInfo = JSON?.parse(localStorage.getItem("userInfo"));
        const country = userInfo?.storeDetails?.countryName ; // need to ask if we are getting country code
       
        switch (country) {
            case 'USA':
                 return 'en-US' ;
                
            case 'United Kingdom':
                const region = userInfo?.storeDetails?.stateCode ;
                switch (region) {
                    case 'NI':
                        return 'GB-NIR'
                   
                    case 'SCT':
                     return 'GB-SCT'
                   
                    case 'WLS':
                    return 'GB-WLS'
                   
                    case 'EN':
                    return 'GB-EN'
                    
                   
                
                    default:
                         case 'EN':
                         return 'GB-EN'
                        
                }
               
           
        
            default:
                return 'en-US' ;
               
        }
    } catch (error) {
        return "";
    }
};

const getUserProfileName = async () => {
    try {
        const getUser = localStorage.getItem("userInfo");
        let user = JSON.parse(getUser);
        return user.firstName + ' ' + user.lastName;
    } catch (error) {
        return "";
    }
};

const PrivateRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem("token");
    const isLogin = localStorage.getItem("isLogin");
    if (isAuthenticated && isLogin) {
        return children;
    } else {
        return <Navigate to="/account/signin" />;
    }
};

const OnlyPublicRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem("token");
    const isLogin = localStorage.getItem("isLogin");
    if (!isAuthenticated && !isLogin) {
        return children;
    } else {
        return <Navigate to="/" />;
    }
};
const logout = async () => {
    try {
        // localStorage.removeItem("token");
        // localStorage.removeItem("isLogin");
        // localStorage.removeItem("userInfo");
        // return <Navigate to="/account/signin" />;

    } catch (error) {
        return "";
    }
};
// eslint-disable-next-line

const isUkCountry = async () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.storeDetails.country == "236" ? true : false;
    } catch (error) {
        return "";
    }
};

const getStoreCurrency = async () => {
    try {
        const data = JSON.parse(localStorage.getItem("ecommerce"));
        return data.storeDetails.currency ? data.storeDetails.currency : "$";
    } catch (error) {
        return "";
    }
};

const getCurrencySymbol = async(currencyCode) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
    });
  
    // Return the currency symbol
    return formatter.formatToParts(123)[0].value;
  };

const ifUKCountry= async () => {
    try {
        const userInfo = JSON?.parse(localStorage.getItem("userInfo"));
        const country = userInfo?.storeDetails?.countryName ; // need to ask if we are getting country code
        if(country == 'United Kingdom'){
            return true;
        }else{
            return false;
        }
       
    } catch (error) {
        return "";
    }
};
// eslint-disable-next-line
export default { getStoreData, getHeaderColor, getFooterColor, getButtonColor, getButtonTextColor, getStoreName, getOrganizationId, setStoreData, getDataById, getParentOrganizationId, setTokenData, getTokenData, checkLogin, setUserData, getUserData, getUserProfileName, PrivateRoute, OnlyPublicRoute, logout, getUserVerification, getCurrency, getStoreLanguage,isUkCountry,ifUKCountry,getStoreCurrency,getCurrencySymbol };
export {
    getStoreData, getHeaderColor, getFooterColor, getButtonColor, getButtonTextColor, getStoreName, getOrganizationId, setStoreData, getDataById, getParentOrganizationId, setTokenData, getTokenData, checkLogin, setUserData, getUserData, getUserProfileName, PrivateRoute, OnlyPublicRoute, logout, getUserVerification, getCurrency, getStoreLanguage,isUkCountry ,ifUKCountry,getStoreCurrency,getCurrencySymbol}